module.exports = __webpack_public_path__ + "img/vacunas6.ecde53eb.jpg";